import PageLayout from "Layouts/PageLayout";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { PrintSizeForm } from "Features/Prints";
import PrintIcon from "Assets/SVG/PrintIcon";
import { usePrintSize } from "Apis/PrintSizeApi";

const Edit = () => {
    
    const { t } = useTranslation();
    
    const { id } = useParams();
    
    const { data: printSize } = usePrintSize(parseInt(id!));
    
    const navigate = useNavigate();
    
    return (
        <PageLayout title={t('updatePrintSize')} icon={<PrintIcon />} includeBox>
            <PrintSizeForm printSize={printSize} onSubmit={_ => navigate(-1)} />
        </PageLayout>
    )
}

export default Edit;
